import hasToken from "@/helper/hasToken";

export default function redirectToLogin(to: any, from: any, next: any): any {
  if (!hasToken()) {
    next({
      name: "Login",
      query: { redirect: to.fullPath },
    });
  }
}
